import {
    GET_MODULE_REQUEST, GET_MODULE_SUCCESS, GET_MODULE_FAIL,
    GET_ALL_MODULES_REQUEST, GET_ALL_MODULES_SUCCESS, GET_ALL_MODULES_FAIL,
    GET_MODULES_BY_STATUS_REQUEST, GET_MODULES_BY_STATUS_SUCCESS, GET_MODULES_BY_STATUS_FAIL,
    GET_ROOT_MODULES_REQUEST, GET_ROOT_MODULES_SUCCESS, GET_ROOT_MODULES_FAIL,
    GET_CHILD_MODULES_REQUEST, GET_CHILD_MODULES_SUCCESS, GET_CHILD_MODULES_FAIL,
    CREATE_MODULE_REQUEST, CREATE_MODULE_SUCCESS, CREATE_MODULE_FAIL,
    UPDATE_MODULE_REQUEST, UPDATE_MODULE_SUCCESS, UPDATE_MODULE_FAIL,
    DELETE_MODULE_REQUEST, DELETE_MODULE_SUCCESS, DELETE_MODULE_FAIL,
    SET_MODULE_LOADING,
} from '../actions/moduleActions';

const initialState = {
    modules: [],
    currentModule: null,
    loading: false,
    message: '',
    error: null,
};

function moduleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULE_LOADING:
            return { ...state, loading: action.payload };

        // --- GET BY ID ---
        case GET_MODULE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_MODULE_SUCCESS:
            return { ...state, currentModule: action.payload, loading: false, message: '' };
        case GET_MODULE_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- GET ALL / BY STATUS / ROOT / CHILDREN (tous peuplent modules[]) ---
        case GET_ALL_MODULES_REQUEST:
        case GET_MODULES_BY_STATUS_REQUEST:
        case GET_ROOT_MODULES_REQUEST:
        case GET_CHILD_MODULES_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_ALL_MODULES_SUCCESS:
        case GET_MODULES_BY_STATUS_SUCCESS:
        case GET_ROOT_MODULES_SUCCESS:
        case GET_CHILD_MODULES_SUCCESS:
            return { ...state, modules: action.payload, loading: false, message: '' };

        case GET_ALL_MODULES_FAIL:
        case GET_MODULES_BY_STATUS_FAIL:
        case GET_ROOT_MODULES_FAIL:
        case GET_CHILD_MODULES_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- CREATE ---
        case CREATE_MODULE_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_MODULE_SUCCESS:
            return {
                ...state,
                modules: [...state.modules, action.payload],
                loading: false,
                message: '',
            };
        case CREATE_MODULE_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- UPDATE ---
        case UPDATE_MODULE_REQUEST:
            return { ...state, loading: true, error: null };
        case UPDATE_MODULE_SUCCESS:
            return {
                ...state,
                modules: state.modules.map((m) =>
                    m.id === action.payload.id ? action.payload : m
                ),
                currentModule:
                    state.currentModule && state.currentModule.id === action.payload.id
                        ? action.payload
                        : state.currentModule,
                loading: false,
                message: '',
            };
        case UPDATE_MODULE_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- DELETE ---
        case DELETE_MODULE_REQUEST:
            return { ...state, loading: true, error: null };
        case DELETE_MODULE_SUCCESS:
            return {
                ...state,
                modules: state.modules.filter((m) => m.id !== action.payload.moduleId),
                currentModule:
                    state.currentModule && state.currentModule.id === action.payload.moduleId
                        ? null
                        : state.currentModule,
                loading: false,
                message: '',
            };
        case DELETE_MODULE_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default moduleReducer;